import styled from 'styled-components';

export const Button = styled.button`
background: transparent;
border: 0;


svg{
    height: 25px;
    width: 25px;
    color: var(--color-line-in-white);
    &:hover{
        opacity: 0.6;

    }
}

`;

export const Profile = styled.div`



`;